<div
    role="group"
    [formGroup]="displaySettingsFormGroup"
    class="agpr-formField agpr-coverageMetricChartDisplaySettingsField"
    [attr.aria-labelledby]="'coverageMetricChartDisplaySettingsField_headerLabel'"
>
    <h3
        class="agpr-coverageMetricChartDisplaySettingsField-header"
        id="coverageMetricChartDisplaySettingsField_headerLabel"
    >
        {{ field.label | localize }}
    </h3>
    <agpr-checkbox
        formControlName="title"
        [id]="'coverageMetricChartDisplaySettingsField_displayTitle'"
        [binary]="true"
        label="Reports.chartSetupDialog.displaySettings.title"
    ></agpr-checkbox>
    <agpr-checkbox
        formControlName="icon"
        [id]="'coverageMetricChartDisplaySettingsField_displayDateRange'"
        [binary]="true"
        label="Reports.chartSetupDialog.displaySettings.icon"
    ></agpr-checkbox>
    @if (!isCustom) {
        <agpr-checkbox
            formControlName="dateRange"
            [id]="'coverageMetricChartDisplaySettingsField_displayDate'"
            [binary]="true"
            label="Reports.chartSetupDialog.displaySettings.date"
        ></agpr-checkbox>
        <agpr-checkbox
            formControlName="sourceLink"
            [id]="'coverageMetricChartDisplaySettingsField_displaySource'"
            [binary]="true"
            [label]="displaySourceAsLink ? 'Reports.chartSetupDialog.displaySettings.source' : 'Reports.chartSetupDialog.displaySettings.sourceLabel'"
        ></agpr-checkbox>
    }
    @if (displayPreviousPeriod) {
        <agpr-checkbox
            formControlName="previousPeriod"
            [id]="'coverageMetricChartDisplaySettingsField_displayPreviousPeriod'"
            [binary]="true"
            label="Reports.chartSetupDialog.displaySettings.previousPeriod"
        ></agpr-checkbox>
    }
    @if (isCustom) {
        <agpr-number-input
            formControlName="customPreviousValue"
            class="agpr-coverageMetricChartDisplaySettingsField-subFirlf"
            [id]="'coverageMetricChartDisplaySettingsField_customPreviousValue'"
            label='Reports.chartSetupDialog.displaySettings.customPreviousValue'
            [min]="0"
            [allowedDecimalUnits]="2"
        ></agpr-number-input>
    }
    @if (!isCustom) {
        <agpr-checkbox
            formControlName="sparkChart"
            [id]="'coverageMetricChartDisplaySettingsField_sparkChart'"
            [binary]="true"
            label='Reports.chartSetupDialog.displaySettings.sparkChart'
        ></agpr-checkbox>
    }
</div>
